<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Membership section title@@customerOverviewComponent.modalTitle.membershipCampai'>Membership (campai)</h3>
    <form [formGroup]="updateMembershipForm" (ngSubmit)="updateMembershipFormSubmit(updateMembershipForm)" id="updateMembershipForm">
      <div app-form-field-text-generic
           [control]="updateMembershipForm.get('membershipNumber')"
           [placeholder]="flTranslations.i18nMembershipNumber"
           [label]="flTranslations.i18nMembershipNumber">
      </div>
      <div class="esf-form-group">
        <div app-form-field-datepicker
             [control]="updateMembershipForm.get('enterDate')"
             [label]="flTranslations.i18nEnterDate"
             [placeholder]="flTranslations.i18nEnterDate">
        </div>
        <div app-form-field-datepicker
             [control]="updateMembershipForm.get('leaveDate')"
             [label]="flTranslations.i18nLeaveDate"
             [placeholder]="flTranslations.i18nLeaveDate">
        </div>
      </div>
      <div app-form-field-text-generic
           [control]="updateMembershipForm.get('sections')"
           [placeholder]="flTranslations.i18nSection"
           [label]="flTranslations.i18nSection">
      </div>
      <div app-form-field-text-generic
           [control]="updateMembershipForm.get('tags')"
           [placeholder]="flTranslations.i18nTags"
           [label]="flTranslations.i18nTags">
      </div>
      <div app-form-field-select
           [control]="updateMembershipForm.get('status')"
           [label]="flTranslations.i18nStatus"
           [array]="currentMembership.statuses">
      </div>
    </form>
    <button class="esf-button esf-button--simple"
            (click)="copyCampaiID()">
      <svg class="esf-icon esf-button__icon" width="16" height="16">
        <use xlink:href="#esf-icon-copy"></use>
      </svg>
      <span class="esf-button__icon-text" i18n="@@general.button.copyCampaiId">Copy Campai ID</span>
    </button>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateMembershipForm'"
                          [isFieldValid]="false"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
